window.theme = window.theme || {};


$(document).ready(function() {
//   var sections = new theme.Sections();

//   sections.register('password-header', theme.PasswordHeader);
  console.log('we hsould now get started')
  
  $(".search-section-closed--mobile").on("click", function() {
    $(this).hide();
    $(".search-container").show();
  })
  $(".search-close-icon").on("click" , function() {
    $(".search-section-closed--mobile").show();
    $(".search-container").hide();
  })
});
